<div class="log-section" if.bind="admin.isAdmin && admin.logExpanded">
  <div class="log-toolbar">
    <span class="log-count">${diagnostics.diagnostics.length} entries</span>
    <div class="log-toolbar-actions">
      <button class="log-clear-btn" click.trigger="admin.clearLog()" disabled.bind="diagnostics.diagnostics.length === 0" title="Clear log">Clear</button>
    </div>
  </div>
  <div class="log-content" ref="diagnostics.logContent">
    <div if.bind="diagnostics.diagnostics.length === 0" class="log-empty">No log entries.</div>
    <div repeat.for="msg of diagnostics.diagnostics" class="diag-line">${msg}</div>
  </div>
</div>
